<template>
    <div>
        <p class="font-weight-bold">Dangerous goods</p>
        <Table :columns="tableColumns" :data="tableData"></Table>
    </div>
</template>
<script>
    export default {
        props: ['row'],
        data () {
            return {
                tableColumns: [
                    {
                        title: 'Quantity',
                        key: 'quantity',
                        maxWidth: 100,
                        align: 'center'
                    },
                    {
                        title: 'Unit',
                        key: 'unit',
                        maxWidth: 120
                    },
                    {
                        title: 'Name',
                        key: 'name',
                        maxWidth: 200,
                    },
                    {
                        title: 'UN Detail',
                        key: 'unDetail'
                    }
                ],
                tableData: [],
            }
        },
        methods: {
            mapDgLines() {
                const that = this;
                this.row.forEach(function (initialDgLine) {
                    const dgLine = {
                        quantity: initialDgLine.quantity,
                        unit: initialDgLine.amount + initialDgLine.unit,
                        name: initialDgLine.product.data.name,
                        unDetail: initialDgLine.product.data.unDetails,
                    };
                    that.tableData.push(dgLine);
                })
            }
        },
        mounted() {
            this.mapDgLines();
        },
    };
</script>

<style scoped>

</style>